import { render, staticRenderFns } from "./fqy.vue?vue&type=template&id=ecd850a4&scoped=true&"
import script from "./fqy.vue?vue&type=script&lang=js&"
export * from "./fqy.vue?vue&type=script&lang=js&"
import style0 from "./fqy.vue?vue&type=style&index=0&id=ecd850a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd850a4",
  null
  
)

export default component.exports